
/** アンカーリンクへスクロール */
export const scrollIntoView = () => {
  const hash = window.location.hash;
  if (!hash) return;

  const id = hash.replace('#', '');
  const element = document.getElementById(id);

  if (element) {
    const top = element.getBoundingClientRect().top + window.scrollY - 100;
    window.scrollTo({ top, behavior: 'auto' });
  }
}
